import './Tiles.css'
import TandCfooter from './TandCfooter'

const CategoryTile = props => {
    //console.log('CategoryTile props:',props.info)
    const {category_title,category_link,category_image,category_description,category_secondary_text,tnc,symbol,overlay_image} = props.info
    const bgImage = props.bgImage
    const headerColor = props.headerColor
    
    return(
        <div className="whitetiles-card__wrapper border-all border-graylight bg-white marg-5 pos-relative width-100" style={{backgroundImage:`url(${bgImage})`,backgroundRepeat: 'no-repeat',backgroundPosition:'center',backgroundSize: 'cover'}}>
            <a href={category_link} onClick={props.onClick} className="home-white-tile home-white-tile__inner unselectable">
                <section  className="body-tile-copy">
                    <header className="home-white-tile-header marg-top-10" style={headerColor !== '' ? {backgroundColor:`${headerColor}`} : {backgroundColor : 'red'}}>{category_title}<sup>{symbol}</sup></header> 
                    <div className="clearfix marg-top-5">
                    <p className="home-white-tile__no-price-header text-black text-center text-upper marg-top-5 text-extra-bold text-size-150 line-height-xs">{category_description}</p>
                    <p className="marg-top-5 text-black text-center text-size-110 line-height-1">{category_secondary_text}</p>
                    <img alt={category_title} className="img-responsive lazy unselectable" loading="lazy" src={category_image} draggable="fasle"/>
                   
                    </div>
                    {overlay_image !== '' ? <img alt="The Good Guys Sale" className="home-white-tile_overlay-img img-responsive lazy pos-absolute" src={overlay_image}/> : null}
                    
                </section>
                {tnc !== '' ? <TandCfooter info={tnc}/> : null} 
            </a>
            
        </div>
    )
}

export default CategoryTile



           